import { SET_EXIT_SURVEY } from "./../../actions/exitsurvey/ExitSurveyAction";

export default function(state = { exitSurvey: null }, action) {
  if (action.type === SET_EXIT_SURVEY) {
    return { ...state, exitSurvey: action.payload };
  } else {
    return state;
  }
}
